<template>
    <div class="page_search">
        <a-form class="search_form" layout="inline">
            <!-- <div v-for="(searcher, index) in searchers" :key="searcher.id"> -->
                <a-form-item :label="searcher.type=='server'?null:searcher.label" :validate-status="validations[index].status" :help="validations[index].help"  v-for="(searcher, index) in searchers" :key="searcher.id">
                    <!-- 日期选择 -->
                    <a-date-picker v-if="searcher.type == 'date'" style="width:210px" :allowClear="false"
                        v-model="vals[index]" :defaultValue="searcher.val" 
                        @change="validations[index]={status:'success', help:null}"/>
                    <a-date-picker v-if="searcher.type == 'time'" style="width:210px" :allowClear="false" 
                        format="YYYY-MM-DD HH:mm:ss"
                        v-model="vals[index]" :defaultValue="searcher.val" 
                        @change="validations[index]={status:'success', help:null}"
                        show-time/>
                    <!-- 月份选择 -->
                    <a-month-picker v-if="searcher.type == 'month'" style="width:210px" :allowClear="false"
                        v-model="vals[index]" :defaultValue="searcher.val" 
                        @change="validations[index]={status:'success', help:null}"/>
                    <a-range-picker style="width:210px"  :allowClear="false" v-if="searcher.type == 'daterange' && !searcher.split" :defaultValue="searcher.val" v-model="vals[index]" @change="validations[index]={status:'success', help:null}"/>
                    <a-range-picker style="width:350px"  :allowClear="false" v-if="searcher.type == 'timerange'" :show-time="{ format: 'HH:mm:ss' }" format="YYYY-MM-DD HH:mm:ss" :defaultValue="searcher.val" v-model="vals[index]" @change="validations[index]={status:'success', help:null}" :ranges="timepicker_ranges"/>         
                    <a-radio-group :options="searcher.options" v-if="searcher.type == 'radio'" :defaultValue="searcher.val" v-model="vals[index]" @change="validations[index]={status:'success', help:null}"></a-radio-group>
                    <a-checkbox-group :options="searcher.options" v-if="searcher.type == 'checkbox'" :defaultValue="searcher.val" v-model="vals[index]" @change="validations[index]={status:'success', help:null}"/>
                    <a-select v-if="searcher.type == 'select' && searcher.multiple!=true" style="min-width: 210px" :defaultValue="searcher.val" v-model="vals[index]" @change="validations[index]={status:'success', help:null}"
                        :placeholder="searcher.placeholder" showSearch optionFilterProp="label">
                        <template v-for="(option, oindex) in searcher.options">
                            <a-select-opt-group v-if="option.options" :label="option.label" :key="oindex">
                                <a-select-option :title="option.label" :value="suboption.value" :label="suboption.label" v-for="suboption in option.options" :key="suboption.value">{{suboption.label}}</a-select-option>
                            </a-select-opt-group>
                            <a-select-option :title="option.label" :value="option.value" :label="option.label" v-if="!(option.options)" :key="oindex">{{option.label}}</a-select-option>
                        </template>
                    </a-select>
                    
                    <a-select mode="multiple" :maxTagCount="5" optionFilterProp="label"
                        v-if="searcher.type == 'select' && searcher.multiple==true" style="min-width: 210px" :defaultValue="searcher.val" v-model="vals[index]" @change="validations[index]={status:'success', help:null}"
                        :placeholder="searcher.placeholder">
                        <div slot="dropdownRender" slot-scope="menu" @mousedown="e=>e.preventDefault()">
                            <v-nodes :vnodes="menu" />
                            <a-divider style="margin: 4px 0;" />
                            <div style="padding: 8px; cursor: pointer;"><a-checkbox @change="selectAll(index, $event)">{{$t("pageHeader.checkAll")}}</a-checkbox></div>
                        </div>
                        <template v-for="(option, oindex) in searcher.options">
                            <a-select-opt-group v-if="option.options" :label="option.label" :key="oindex" >
                                <a-select-option :title="suboption.label" :value="suboption.value" :label="suboption.label" v-for="suboption in option.options" :key="suboption.value">{{suboption.label}}</a-select-option>
                            </a-select-opt-group>
                            <a-select-option :value="option.value" :label="option.label" v-if="!(option.options)" :key="oindex">{{option.label}}</a-select-option>
                        </template>
                    </a-select>

                    <a-cascader :options="searcher.options" v-if="searcher.type == 'cascader'" :defaultValue="searcher.val" v-model="vals[index]" @change="validations[index]={status:'success', help:null}" 
                        :placeholder="searcher.placeholder"/>
                    <a-textarea :style="searcher.height || searcher.width?{width:searcher.width?`${searcher.width}px`:'210px', height: searcher.height?`${searcher.height}px`:'auto'}:{}" :autosize="searcher.height || searcher.width?false:true" :placeholder="searcher.placeholder" v-if="searcher.type == 'input'" :defaultValue="searcher.val" v-model="vals[index]" @change="validations[index]={status:'success', help:null}"/>
                    <Server v-if="searcher.type == 'server' && type!='cache'" v-model="vals[index]"  pos="left"
                        :placeholder="searcher.placeholder" :label="searcher.label" :defaultValue="searcher.val" :single="searcher.single"
                        @change="validations[index]={status:'success', help:null}"/>
                    <RangePicker v-if="searcher.type == 'daterange' && searcher.split" :defaultValue="searcher.val" v-model="vals[index]" @change="validations[index]={status:'success', help:null}" />
                    <!-- 新增单列多选 -->
                    <Outterselect v-if="searcher.type=='outterselect'" v-model="vals[index]" 
                        :placeholder="searcher.placeholder" 
                        :label="searcher.label" 
                        :options="searcher.options"
                        @change="validations[index]={status:'success', help:null}" />
                </a-form-item>
            <!-- </div> -->
            <div>
                <a-form-item>
                    <a-button type="primary" html-type="submit" @click="submit">{{download?$t("common.download"):$t("common.find")}}</a-button>
                    <a-button :style="{ marginLeft: '8px' }" @click="reset">{{$t("common.reset")}}</a-button>
                </a-form-item>
            </div>
        </a-form>
        <template v-for="(searcher, index) in searchers">
            <OutterList v-model="vals[index]" :key="index" :label="searcher.label" :options="searcher.options" v-if="searcher.type=='outterselect'"/>
            <ServerList v-model="vals[index]" :key="index" v-if="searcher.type=='server'&& searcher.single!=true"/>
        </template>
    </div>
</template>  

<script>
import {Form, DatePicker, Radio, Select, Input, Checkbox, Cascader} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Form)
Vue.use(DatePicker)
Vue.use(Radio)
Vue.use(Select)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Cascader)

import storage from '@/utils/storage'
import Server from '@/components/common/search/server.vue'
import ServerList from '@/components/common/search/server_list.vue'
import Outterselect from '@/components/common/search/outterselect.vue'
import OutterList from '@/components/common/search/outter_list.vue'
import RangePicker from '@/components/common/search/range_picker.vue'
import moment from 'moment'

export default {
    props: ['items', 'download', 'type'],
    components: {
        Server,
        ServerList,
        Outterselect,
        OutterList,
        RangePicker, 
        VNodes: {
            functional: true,
            render: (h, ctx) => ctx.props.vnodes,
        },
    },
    mounted() {
        this.initSearcher()
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    computed: {
        remember() {
            return this.$store.state.config.remember
        },
    },
    watch: {
        items() {
            this.initSearcher()
        },
        remember(val) {
            if (val) {
                this.saveRemember()
            } else {
                this.removeRember()
            }
        },
    },
    data() {
        return {
            searchers: [],
            vals:[],
            validations:[],
            timepicker_ranges: {
                '最近10分钟': [moment().subtract(10, 'minute'), moment()],
                '最近30分钟': [moment().subtract(30, 'minute'), moment()],
                '最近1小时': [moment().subtract(1, 'hour'), moment()],
                '最近6小时': [moment().subtract(6, 'hour'), moment()],
                '最近12小时': [moment().subtract(12, 'hour'), moment()],
                '最近24小时': [moment().subtract(24, 'hour'), moment()],
            }
        }
    },
    methods: {
        saveRemember() { 
            let all_params = storage.local.get('search')
            if(!all_params) {
                all_params = {}
            }

            let params = all_params[this.$service.PROJ_CODE]
            if(!params) {
                params = {}
            }
            
            let keys = ['dt', 'start_dt', 'end_dt', 'selectdate', 'servers']
            keys.forEach((id) => {
                let index = _.findIndex(this.searchers, {id})
                if(index>=0) {
                    if (id == 'dt' && this.searchers[index].type=='daterange') {
                        let start_dt = this.vals[index][0].format('YYYY-MM-DD')
                        let end_dt = this.vals[index][1].format('YYYY-MM-DD')
                        params[id] = [start_dt, end_dt]
                        params['start_dt'] = start_dt
                        params['end_dt'] = end_dt
                    }
                    else if (['start_dt', 'end_dt', 'selectdate', 'dt'].indexOf(id)>=0 && this.searchers[index].type=='date') {
                        params[id] = this.vals[index].format('YYYY-MM-DD')
                    }
                    else if(id=='servers' && this.searchers[index].type=='server') {
                        params[id] = this.vals[index]
                    }
                }
            })
            all_params[this.$service.PROJ_CODE] = params
            storage.local.set('search', all_params);
        },
        removeRember() {
            storage.local.remove('search');
        },
        initSearcher() {
            this.searchers = _.cloneDeep(this.items)
            let hasTimerange = false
            this.searchers.forEach((searcher)=>{
                if(searcher.type=='select' && searcher.multiple==true) {
                    let all = []
                    searcher.options.forEach((option)=>{
                        if(option.options) {
                            option.options.forEach((sub)=>{
                                all.push(sub.value)
                            })
                        } else {
                            all.push(option.value)
                        }
                    })
                    searcher.allvalue = all
                }
                if(searcher.type === 'timerange') {
                    hasTimerange = true
                }
            })
            if(hasTimerange) {
                this.timer = setInterval(() => {
                    this.timepicker_ranges = {
                        '最近10分钟': [moment().subtract(10, 'minute'), moment()],
                        '最近30分钟': [moment().subtract(30, 'minute'), moment()],
                        '最近1小时': [moment().subtract(1, 'hour'), moment()],
                        '最近6小时': [moment().subtract(6, 'hour'), moment()],
                        '最近12小时': [moment().subtract(12, 'hour'), moment()],
                        '最近24小时': [moment().subtract(24, 'hour'), moment()],
                    }
                }, 1000)
            }
            this.reset()
        },
        selectAll(index, e) {
            if(e.target.checked==true) {
                this.vals.splice(index, 1, this.searchers[index].allvalue)
                this.validations[index] = {status:'success', help:null}
            }
            else {
                this.vals.splice(index, 1, [])
            }
        },
        getDate(val) {
            if(typeof(val) == 'number') {
                if(val > 0) {
                    return moment(new Date()).add(val*24*60, 'minutes')
                } else if (val < 0){
                    return moment(new Date()).subtract(-val*24*60, 'minutes')
                } else {
                    return moment(new Date())
                }
            }
            else if(typeof(val) == 'string') {
                return moment(val)
            }
            else {
                return moment(new Date()).subtract(1, 'days')
            }
        },
        getTime(val) {
            if(typeof(val) == 'number') {
                if(val > 0) {
                    return moment(new Date()).startOf('day').add(val*24*60, 'minutes')
                } else if (val < 0){
                    return moment(new Date()).startOf('day').subtract(-val*24*60, 'minutes')
                } else {
                    return moment(new Date()).startOf('day')
                }
            }
            else if(typeof(val) == 'string') {
                return moment(val)
            }
            else {
                return moment(moment(new Date()).format('YYYY-MM-DD')).subtract(1, 'days')
            }
        },
        getMonth(val) {
            if(typeof(val) == 'number') {
                if(val > 0) {
                    return moment(new Date()).add(val, 'months')
                } else if (val < 0){
                    return moment(new Date()).subtract(-val, 'months')
                } else {
                    return moment(new Date())
                }
            }
            else if(typeof(val) == 'string') {
                return moment(val)
            }
            else {
                return moment(new Date())
            }
        },
        reset() {
            let query_params = this.$route.query
            let all_params = storage.local.get('search')
            if(!all_params) {
                all_params = {}
            }

            let remember_params = all_params[this.$service.PROJ_CODE]
            if(!remember_params) {
                remember_params = {}
            }

            let vals = [], validations=[]
            this.searchers.forEach((searcher) => {
                validations.push({'status':'success', 'help':null})
                let defaultVal = searcher.default
                if(query_params.hasOwnProperty(searcher.id) && searcher.id!='id') {
                    if(searcher.type==='timerange' || searcher.type==='daterange' || searcher.type==='checkbox' || (searcher.type==='select' && searcher.multiple)) {
                        defaultVal = query_params[searcher.id].split(',')
                    }
                    else {
                        defaultVal = query_params[searcher.id]
                    }
                }
                else if(remember_params.hasOwnProperty(searcher.id)) {
                    defaultVal = remember_params[searcher.id]
                }

                if(searcher.type == 'date') {
                    searcher.val = this.getDate(defaultVal)
                }
                else if(searcher.type == 'time') {
                    searcher.val = this.getTime(defaultVal)
                }
                else if(searcher.type == 'month') {
                    searcher.val = this.getMonth(defaultVal)
                }
                else if(searcher.type == 'daterange') {
                    if(defaultVal instanceof Array) {
                        searcher.val = [this.getDate(defaultVal[0]), this.getDate(defaultVal[1])]
                    }
                    else {
                        searcher.val = [this.getDate(null), this.getDate(null)]
                    }
                } 
                else if(searcher.type == 'timerange') {
                    if(defaultVal instanceof Array) {
                        searcher.val = [this.getTime(defaultVal[0]), this.getTime(defaultVal[1])]
                    }
                    else {
                        searcher.val = [this.getTime(null), this.getTime(null)]
                    }
                } 
                else {
                    if(searcher.type == 'checkbox' && !defaultVal) {
                        searcher.val = []
                    }
                    else {
                        searcher.val = defaultVal
                    }
                }
                vals.push(searcher.val)
            })
            this.vals = _.cloneDeep(vals)
            this.validations = _.cloneDeep(validations)
            //this.initParams()
        },
        submit() {
            let params = {}, required=false, error=false
            this.searchers.forEach((searcher, index) => {
                let value = this.vals[index]
                let nullValue = false
                if((value==null || value==undefined) || (searcher.type=='input' && value==='') || ((searcher.type=='checkbox' || (searcher.type=='select' && searcher.multiple) || searcher.type=='outterselect') && value.length==0)) {
                    if(searcher.type=='server') {
                        params[searcher.id] = searcher.all?searcher.all: ''
                    }
                    else if(searcher.nullValue === true) {
                        params[searcher.id] = ''
                        nullValue = true
                    }
                    else {
                        if(searcher.required == true) {
                            this.validations.splice(index, 1 , {'status':'error', 'help': this.$t("pageHeader.mustFill")})
                            required = true
                        }
                        
                    }
                }
                else {
                    if(searcher.type == 'date') {
                        params[searcher.id] = value.format('YYYY-MM-DD')
                    }
                    else if(searcher.type == 'time') {
                        params[searcher.id] = value.format('YYYY-MM-DD HH:mm:ss')
                    }
                    else if(searcher.type == 'month') {
                        params[searcher.id] = value.format('YYYY-MM')
                    }
                    else if(searcher.type == 'daterange') {
                        params[`start_${searcher.id}`] = value[0].format('YYYY-MM-DD')
                        params[`end_${searcher.id}`] = value[1].format('YYYY-MM-DD')
                        if(params[`start_${searcher.id}`] > params[`end_${searcher.id}`]){
                            error=true
                            this.validations.splice(index, 1 , {'status':'error', 'help':'结束日期不能早于起始日期'})
                        }
                    }
                    else if(searcher.type == 'timerange') {
                        params[`start_${searcher.id}`] = value[0].format('YYYY-MM-DD HH:mm:ss')
                        params[`end_${searcher.id}`] = value[1].format('YYYY-MM-DD HH:mm:ss')
                        if(params[`start_${searcher.id}`] > params[`end_${searcher.id}`]){
                            error=true
                            this.validations.splice(index, 1 , {'status':'error', 'help':'结束日期不能早于起始日期'})
                        }
                    }
                    else if(searcher.type == 'checkbox') {
                        if(!searcher.str) {
                            params[searcher.id] = _.join(value, ',')
                        } 
                        else  {
                            let val = _.join(value, "','")
                            if(val != '')
                                val = `'${val}'`
                            params[searcher.id] = val
                        }
                    }
                    else if(searcher.type == 'select' && searcher.multiple==true) {
                        params[searcher.id] = _.join(value, ',')
                    }
                    else if(searcher.type == 'outterselect') {
                        params[searcher.id] = _.join(value, ',')
                    }
                    else if(searcher.type == 'cascader') {
                        params[searcher.id] = _.join(value, ',')
                    }
                    else if(searcher.type == 'server') {
                        if(searcher.single==true) {
                            params[searcher.id] = value
                        }
                        else {
                            let val = ""
                            if(searcher.default_type == 'string') {
                                val = _.join(value, '","')
                                if(value.length>0) {
                                    val = `"${val}"`
                                }
                            }
                            else {
                                val = _.join(value, ',')
                            }
                            
                            if(val == '' && searcher.all)
                                val = searcher.all
                            params[searcher.id] = val
                        }
                    }
                    else {
                        params[searcher.id] = value
                    }
                }
                if(params[searcher.id]!=null && params[searcher.id]!=undefined && !(searcher.type=='server' && params[searcher.id]=='') && !nullValue) {
                    if(searcher.default_type == 'string') {
                        params[searcher.id] = params[searcher.id].toString()
                    } 
                    else if(searcher.default_type == 'number') {
                        let newVal = Number(params[searcher.id])
                        if((newVal==null || newVal==undefined || isNaN(newVal)) && searcher.type=='input') {
                            error = true
                            this.validations.splice(index, 1 , {'status':'error', 'help':'请填写数字'})
                        }
                        else {
                            params[searcher.id] = newVal
                        }
                    }
                    if(searcher.prefix || searcher.suffix) {
                        params[searcher.id] = `${searcher.prefix?searcher.prefix:''}${params[searcher.id]}${searcher.suffix?searcher.suffix:''}`
                    }
                }
            })
            if(required==true || error==true) {
                return
            }
            if (this.remember) {
                this.saveRemember()
            }
            this.$emit('search', params)
        }
    },
}
</script>

<style lang="less">
// .page_search {
//     padding: 10px 30px 20px 30px;
//     .ant-form-item {
//         margin:10px 20px 0 0 ;
//         label {
//             display:inline-block;
//         }
//     }
// }
.page_search {
    background: #fff;
    padding: 10px 30px 20px 30px;
    .ant-form-item {
        margin-top:10px ;
    }
}
</style>